<template>
  <div class="box">
    <div class="box_header">
      <div class="rounded-container">
        <el-input
          placeholder="请输入实验教室名称"
          v-model="formData.searchValue"
          class="rounded-input"
          @input="searchViewList"
        ></el-input>
      </div>
    </div>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <component
          :is="componentType"
          :list="list"
          @handleCheckboxChange="handleCheckboxChange"
          @toggleExpand="toggleExpand"
        />
      </van-list>
    </div>
    <van-action-sheet
      v-model="show"
      title="预约须知"
      v-if="componentType === 'ApplyRoomList'"
    >
      <div style="padding: 16px 16px 16px; margin-bottom: 28px">
        <p
          style="
            color: #000;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 15px;
          "
        >
          使用规则和注意事项
        </p>
        <div v-html="labOpenRemark"></div>
        <!-- <p class="text"><span>预约时长</span>: 单次预约时长不得超过2节课，最多提前3天预约，系统无法预约当天实验室</p>
        <p class="text"><span>设备使用‌</span>: 实验设备使用过程中如有问题，需及时上报实验员‌。</p>
        <p class="text"><span>‌安全责任‌</span>: 申请人及导师对实验室的安全使用负全责‌。</p>
        <p class="text"><span>‌特殊情况‌</span>: 如有特殊情况需延长使用时间，需提前联系实验员重新预约‌。</p>
        <p class="text"><span>‌寒暑假及节假日‌</span>: 寒暑假及国家法定节假日期间申请使用实验室需经学院讨论同意‌。</p> -->
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <div
            style="
              width: 165px;
              height: 50px;
              border: 1px solid #e5e5e5;
              border-radius: 25px;
              line-height: 45px;
              text-align: center;
              font-weight: 500;
              font-size: 18px;
              color: #666666;
              cursor: pointer;
            "
            @click="show = false"
          >
            不同意
          </div>
          <div
            style="
              width: 165px;
              height: 50px;
              border: 1px solid #e5e5e5;
              background: #13499b;
              border-radius: 25px;
              line-height: 45px;
              text-align: center;
              font-weight: 500;
              font-size: 18px;
              color: #fff;
              cursor: pointer;
            "
            @click="goAgree()"
          >
            同意
          </div>
        </div>
      </div>
    </van-action-sheet>
    <div class="bottom_box" v-if="componentType === 'ApplyRoomList'">
      <el-button class="yuyue__tomy" round @click="goToMyReservation"
        >我的预约</el-button
      >
      <el-button class="yuyue__topost" round @click="goToReservation"
        >立即预约</el-button
      >
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
import { Toast } from "vant";
import ApplyRoomList from "./components/ApplyRoomList.vue";

export default {
  components: { ApplyRoomList },
  data() {
    return {
      componentType: 'ApplyRoomList',
      labOpenRemark: "",
      classRoomOption: [], //学院列表
      formData: {
        searchValue: "", // 搜索框的绑定
      },
      show: false,
      orgName: "",
      labName: "",
      loading: false,
      finished: false,
      total: 0,
      page: 1, // 当前页码
      pageSize: 12, // 每页加载的数据量
      options: [],
      list: [],
      selectedCard: {},
      firstLoadWithSearch: true,
      previousSearchValue: "",
    };
  },
  methods: {
    toggleExpand(id) {
      this.list.forEach((item, index) => {
        if ((item.labId || item.id) === id) {
          this.list[index].expand = !this.list[index].expand;
        }
      });
    },
    goToMyReservation() {
      this.$router.push("/myApply");
    },
    async goToReservation() {
      if (this.selectedCard.labId) {
        this.show = true;
        const res = await axios.post(
          "/baseinfo/getLabInfosDetail2?id=" + this.selectedCard.labId
        );
        this.labOpenRemark = res.data.labOpenRemark ?? "<p>暂无说明</p>";
      } else {
        Toast("请选择预约实验室");
      }
    },
    handleCheckboxChange(id) {
      let selected = {};
      this.list.forEach((item, index) => {
        if (item.Id === id) {
          const newCheckState = !item.check;
          this.$set(this.list[index], "check", newCheckState);
          if (newCheckState) {
            selected = item;
          }
        } else {
          this.$set(this.list[index], "check", false);
        }
      });
      this.selectedCard = selected;
    },
    // 切换学院下拉菜单
    changeCollege(value) {
      const collage = this.classRoomOption.filter((item) => {
        return item.value === value;
      });
      if (collage) this.formData.selectName = collage[0].label;
      this.list = [];
      this.page = 1; // 确保从第一页开始
      this.finished = false;
      this.getLabList();
    },
    goAgree() {
      this.$router.push({
        path: "/reservation",
        query: {
          labName: this.selectedCard.labName,
          labId: this.selectedCard.labId,
        },
      });
    },
    async searchViewList() {
      try {
        this.page = 1; // 确保从第一页开始
        await this.getLabList();
      } catch (error) {
        this.finished = true;
        this.loading = false;
      }
    },
    async onLoad() {
      if (this.finished || !this.list.length) return;
      // 更新页码
      this.page++;
      this.getLabList({ page: this.page });
    },
    async getCollageList() {
      const listForm = this.translateForm({ type: "2", status: 2 });
      const { data, status } = await axios.post(
        "/baseinfo/getOrgSelectFromUser",
        listForm,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (status === 200) {
        this.classRoomOption = data.map((roomData) => {
          return { label: roomData.name, value: roomData.id };
        });
      }
    },

    async getLabList(args) {
      const page = args ? args.page ?? this.page : this.page
      const pageSize = args ? args.pageSize ?? this.pageSize : this.pageSize
      const formDataTranslate = this.translateForm({
        labName: this.formData.searchValue,
        xyName: this.$route.query.name,
        page,
        pageSize
      });

      try {
        const response = await axios.post('/labOpen/getMWPhoneOpenLabList', formDataTranslate, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 200) {
          const { data, total } = response.data;
          const clData = data.map((item) => {
            return {
              ...item,
              expand: false,
            };
          });
          if (args && args.page) {
            this.list = [...this.list, ...clData];
          } else {
            this.list = clData;
          }
          this.total = total;
          this.loading = false;

          // 如果当前加载的数据量等于总数据量，则设置 finished 为 true
          if (this.list.length >= this.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      } catch (error) {
        this.finished = true;
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getLabList();
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  background-color: #f3f3f3;
  height: calc(calc(100vh - 65px));
}
.reset {
  margin-left: 5px;
}
.box .box_header {
  display: flex;
  padding: 10px;
  width: 100%;
}
.rounded-container {
  display: flex;
  flex: 1;
  border-radius: 20px;
  overflow: hidden; /* 确保子元素不会溢出圆角 */
}
.rounded-input {
  flex: 1;
  background-color: #f2f2f4 !important;
}
::v-deep .rounded-input .el-input-group {
  background-color: #f2f2f4 !important;
  border-radius: 20px !important;
}

::v-deep .rounded-input .el-input-group__prepend,
::v-deep .rounded-input .el-input__inner {
  border: none !important;
}
::v-deep .select-with-search .el-input__inner {
  border: 0;
}
.select-with-search {
  width: 100px;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  background-color: #fff !important; /* 确保选择器背景与输入框一致 */
}
.content {
  width: 100%;
  height: calc(calc(100vh - 65px) - 75px);
  overflow-y: auto;
  padding: 0 15px;
}
::v-deep .el-card__body,
.el-main {
  padding: 14px 20px;
}
::v-deep .el-card__header {
  padding: 0;
  position: relative;
}
.tag {
  position: absolute;
  right: 0;
  top: 0;
  width: 62px;
  height: 26px;
  background: #13499b;
  border-radius: 0 8px 0 8px;
  color: #ffffff;
  text-align: center;
  line-height: 26px;
}
.tag1 {
  position: absolute;
  right: 0;
  top: 0;
  width: 62px;
  height: 26px;
  background: #e4e7ec;
  border-radius: 0 8px 0 8px;
  color: #666666;
  text-align: center;
  line-height: 26px;
}
.bottom_box {
  display: flex;
  width: 100%;
  z-index: 999;
  height: 80px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  padding: 18px 15px;
  line-height: 80px;
}
.bottom_box .yuyue__tomy {
  flex: 1;
  background-color: #329977;
  color: #ffffff;
  border: none;
}
.bottom_box .yuyue__topost {
  flex: 1;
  background-color: #13499b;
  color: #ffffff;
  border: none;
}
</style>
